/**
 * Interpreter workspace chat docking (web).
 *
 * On a wide enough screen the interpreter's room keeps chat pinned beside the
 * video with the queue and shift tools. The decision must come from the real
 * window width. `features/base/responsive-ui` clientWidth is NOT that: it
 * already subtracts the open chat (CHAT_SIZE) — so deciding from it docks the
 * chat, which opens it, which shrinks clientWidth, which un-docks it, which
 * closes it, which grows clientWidth… a synchronous render loop that froze
 * every interpreter room between 1024 and 1339 px wide (prod, 2026-09-20).
 */
export const INTERPRETER_CHAT_DOCK_MIN_WIDTH = 1024;
/** Whether a window this wide keeps the interpreter chat docked. */
export function shouldDockInterpreterChat(windowWidth) {
    return Number.isFinite(windowWidth) && windowWidth >= INTERPRETER_CHAT_DOCK_MIN_WIDTH;
}
/** The real viewport width, independent of any open side panel. */
export function getWindowWidth() {
    return typeof window === 'undefined' ? 0 : window.innerWidth;
}
